
<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="产品编码" prop="materialCode">
                            <el-input v-model="formInline.materialCode" placeholder="请输入"
                                      clearable style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="产品名称" prop="materialName">
                            <el-input v-model="formInline.materialName" placeholder="请输入"
                                      clearable style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="改制要求" prop="specificReform">
                            <el-input v-model="formInline.specificReform" placeholder="请输入"
                                      clearable style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="个性化定制标准描述" prop="individualizeReform">
                            <el-input v-model="formInline.individualizeReform" placeholder="请输入"
                                      clearable style="width: 100%"></el-input>
                        </el-form-item>
                    </div>

                </el-form>
                <div class="l-screenBox">
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createOpen">
                            新增
                        </el-button>
                    </div>
                </div>
            </div>
            <!--数据展示-->
            <div class="h-table h-mrt30">
                <el-table
                    :data="tableData"
                    ref="multipleTable"
                    :border="true"
                    :span-method="objectSpanMethod"
                    style="width: 100%"
                    max-height="450"
                >

                    <el-table-column
                        type="index"
                        label="序号"
                        width="55"
                        fixed="left"
                    >
                    </el-table-column>
                    <el-table-column
                        label="产品编码"
                        prop="materialCode"
                        width="110"
                        fixed="left"
                        :show-overflow-tooltip="true" >
                    </el-table-column>
                    <el-table-column
                        label="产品名称"
                        prop="materialName"
                        width="120"
                        fixed="left"
                        :show-overflow-tooltip="true" >
                    </el-table-column>
                    <el-table-column
                        label="改制要求"
                        prop="specificReform"
                        width="150"
                    >
                    </el-table-column>
                    <el-table-column
                        label="个性化定制标准描述"
                        prop="individualizeReform"
                        width="150"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="是否只能生产改"
                        width="120"
                        prop="onlyProduction"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="单台加价"
                        prop="reformPrice"
                        width="100"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="改制技术要求"
                        prop="reformCountRequire"
                        width="150"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="审核状态"
                        prop="status"
                        width="150" >
                        <template slot-scope="scope">
                            {{
                                {
                                    '1': '暂存',
                                    '2': '审核中',
                                    '3': '审核通过',
                                    '4': '驳回'
                                }[scope.row.status] || scope.row.status
                            }}
                        </template>
                    </el-table-column>


                    <el-table-column
                        label="改制新增物料号"
                        prop="addMaterialCode"
                        width="130"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="新增物料名称"
                        prop="addMaterialName"
                        width="130"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="新增物料单耗"
                        prop="addMaterialOrder"
                        width="120"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="替换物料号"
                        prop="replaceMaterialCode"
                        width="120"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="替换物料名称"
                        prop="replaceMaterialName"
                        width="120"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="替换物料单耗"
                        prop="replaceMaterialOrder"
                        width="120"
                        show-overflow-tooltip>
                    </el-table-column>

                    <el-table-column
                        label="备注"
                        prop="remark"
                        width="120"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="创建人"
                        prop="cucode"
                        width="150"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.cuname + "[" + scope.row.cucode + "]" }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="创建时间"
                        prop="cdate"
                        width="110"
                        :formatter="formatDate"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="最后更新人编码"
                        prop="lucode"
                        width="130"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        label="最后更新时间"
                        prop="ldate"
                        width="110"
                        :formatter="formatDate"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        width="200"
                        label="操作">
                        <template slot-scope="scope">
                            <div style="display: flex;align-items: center;justify-content: center;">
                                <el-button
                                    size="small" class="h-tableLink h-btn"
                                    style="margin-left: 0;"
                                    @click="checkOpen(scope.row)">
                                    查看
                                </el-button>
                                <el-button
                                    v-if="scope.row.instid"
                                    style="margin-left: 0;"
                                    size="small"
                                    class="h-tableLink h-btn">
                                    <span  @click="showshenpi(scope.row.instid)">跟踪</span>
                                </el-button>
                                <el-button
                                    size="small"
                                    class="h-tableLink h-btn"
                                    style="margin-left: 0;"
                                    v-if="scope.row.status!=2"
                                    @click="updateOpen(scope.row)">
                                    {{
                                        {
                                            '1': '提交',
                                            '3': '修改',
                                            '4': '重新提交'
                                        }[scope.row.status] || '修改'
                                    }}
                                </el-button>
                                <el-button
                                    size="small" class="h-tableLink h-btn"
                                    style="margin-left: 0;"
                                    v-if="scope.row.status!=2"
                                    @click="toDelete(scope.row)">
                                    删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class ="h-btn h-formBtn h-bgblueQ" @click="exportExcel">批量导出</el-button>
                        <el-button
                            class="h-btn h-formBtn h-bgblueQ"
                            icon="h-el-icon h-el-icon-export"
                            @click="uploaddownexcelflagbtn">
                            批量导入
                        </el-button>
                        <uploaddownexcel
                            :visible.sync="uploaddownexcelflag"
                            v-if="uploaddownexcelflag"
                            clsname="bscReformToMaterialImportExcel"
                            :startrow="1"
                            @callback="uploadExcelFilecallback"/>
                    </div>
                </div>
                <div class="h-pagination2">
                    <pagination :page="formInline" @query="query"/>
                </div>

                <viewhistory :visible.sync="showHistory" v-if="showHistory" :id="instId"/>
            </div>
        </div>
    </div>
</template>
<script>import reformToMaterial from "@/api/reformToMaterial/reformToMaterial";
import updownfile from "@/utils/updownfile";
import ss from "@/api/SystemService";
import uploaddownexcel from "@/components/uploaddown/uploaddownexcel.vue";
export default {
    components: {uploaddownexcel},
    data() {
        return {
            formInline: {
                materialCode: null,
                materialName: null,
                specificReform: null,
                individualizeReform: null,
                onlyProduction: null,
                reformCountRequire: null,

                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
            instId:null,
            showHistory: false,
            isScreen: false,
            closeScreen: require("@/assets/images/pimg/closeallic.png"),
            drawScreen: require("@/assets/images/pimg/dobleArr.png"),
            spanArr: [],
            tableData: [],
            //批量导入
            uploaddownexcelflag: false,
        }
    },
    methods: {
        query() {
            reformToMaterial.selectPage(this.formInline).then(rd => {
                this.tableData = rd.records;
                this.formInline.total = rd.total || 0;
                this.getSpanArr();
             })
        },
        getSpanArr () {
            this.spanArr = [];
            this.tableData.forEach((item, index) => {
                if (index === 0) {
                    this.spanArr.push(1);
                    this.position = 0;
                } else {
                    if (this.tableData[index].id === this.tableData[index - 1].id) {
                        this.spanArr[this.position] += 1;
                        this.spanArr.push(0);
                    } else {
                        this.spanArr.push(1);
                        this.position = index;
                    }
                }
            })
        },
        // id相同的行上下合并（产品编码~单台加价）
        objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
            if (
                (column.property == 'materialCode')
                ||
                (column.property == 'materialName')
                ||
                (column.property == 'specificReform')
                ||
                (column.property == 'individualizeReform')
                ||
                (column.property == 'onlyProduction')
                ||
                (column.property == 'reformPrice')
                ||
                (column.property == 'reformCountRequire')
                ||
                (column.property == 'status')
                ||
                (column.property == 'cucode')
                ||
                (column.property == 'cdate')
                ||
                (column.property == 'lucode')
                ||
                (column.property == 'ldate')
                ||
                (column.property == 'remark')
                ||
                ( column.label == '操作')

            ) {
                const _row = this.spanArr[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return {
                    rowspan: _row,
                    colspan: _col
                }
            }
        },
        handleFilter() {
            this.formInline.pageNo = 1;
            this.query()
        },
        resetData() {
            this.formInline = {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            }
            this.query()
        },
        exportExcel() {
            updownfile.down("/api/swyl/v1/demo/bscReformToMaterial/downloadExcel", this.formInline, "get", 'data');
        },
        uploaddownexcelflagbtn() {
            this.uploaddownexcelflag = true;
        },
        uploadExcelFilecallback(rd) {
            this.query();
            this.$msg.msgs(rd.msg);
        },
        formatDate(row, column) {
            // 获取单元格数据
            let data = row[column.property]
            if(data == null || data === '') {
                return null
            }
            let dt = new Date(data)
            return this.$util.riQi3(dt);
        },

        createOpen(){
            this.$router.push({path: "/chanp/addReformToMaterial"});
        },

        updateOpen(row){
            //驳回状态(4)的数据:按重新提交处理,带上流程参数
            if (row.status == 4 || row.status == '4') {
                this.$router.push({
                    path: "/chanp/addReformToMaterial",
                    query: {ywid: row.id, instid: row.instid, chongXinTiJiao: 1}
                });
                return;
            }
            this.$router.push({path: "/chanp/addReformToMaterial", query: {id: row.id}});
        },

        checkOpen(row){
            this.$router.push({path: "/chanp/addReformToMaterial", query: {id: row.id, viewMode: 1}});
        },
        showshenpi(v){
            this.instId = v;
            this.showHistory = true;
        },
        //删除
        toDelete(row) {
            this.$msg.confirm("确认删除?", () => {
                reformToMaterial.deleteById(row.id).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.query();
                });
            });
        },
    },
    created() {
        this.query();
    },
    activated() {
        this.query()
    }
}
</script>

<style scoped>
    .expand-content {
        padding: 10px;
        background-color: #fafafa;
        border: 1px solid #ebeef5;
        border-radius: 4px;
    }
</style>
